import {createAction, props} from "@ngrx/store";
import {AcHTTPResponse} from "../../../../core/http/http-response.models";
import {SearchResponseData, SearchResponseMetaData} from "./search.models";


export const searchAction = createAction('[Search] Search', props<{ q: string }>());
export const searchSuccessAction = createAction('[Search] Search Success', props<{ result: AcHTTPResponse<SearchResponseData, SearchResponseMetaData>; }>());
export const searchErrorAction = createAction('[Search] Search Error', props<{ error: any }>());

